import Vue from 'vue';
import {
  getClaims as getClaimsCall,
  saveClaims as saveClaimsCall
} from '@/api/claims';
import { GLOBAL_ERROR } from '@/utils/constants';
import postFiles from '../../utils/post-files';
import { parseTimestamp } from '@eui-util/date';
import _round from 'lodash/round';

/**
 * Get a list of claims for the user and store it in this modules state
 *
 * @param commit
 * @param dispatch
 * @param status
 * @returns {Promise<*>}
 */
export function getClaims({ commit, dispatch, state, rootState }) {
  return new Promise(async (resolve, reject) => {
    try {
      if (!rootState.lease.selectedLease.id) {
        return;
      }
      commit('setClaims', []);
      commit('setState', ['claimsLoading', true]);
      const claims = await getClaimsCall({
        status: state.selectedStatus,
        leaseId: rootState.lease.selectedLease.id
      });
      commit('setClaims', claims);
      commit('setState', ['claimsLoading', false]);
      resolve();
    } catch (err) {
      commit('setState', ['claimsLoading', false]);
      // eslint-disable-next-line
      console.error(err);
      Vue.prototype.$euiNotifications.emit({
        notification: GLOBAL_ERROR,
        action: () => dispatch('getClaims')
      });
      return reject();
    }
  });
}

export function createClaim({ commit, dispatch }, { payload, files }) {
  return new Promise(async (resolve, reject) => {
    try {
      commit('setState', ['claimSaving', true]);
      const amountGst = _round(payload.amountTotal / 11, 2);
      const isEv = payload.claimType === 'fuel/electricity'

      // bank details are correct if none are being sent through
      const data = {
        leaseId: payload.leaseId,
        claimType: payload.claimType,
        accountName: payload.accountName,
        bsb: payload.bsb,
        accountNumber: payload.accountNumber,
        bankDetailsCorrect:
          !payload.accountNumber && !payload.bsb && !payload.accountName,
        claimDate: parseTimestamp(Date.now() / 1000, 'yyyy-MM-dd'),
        description: payload.description || '',
        amountNet: isEv ? payload.amountTotal : Number(payload.amountTotal - amountGst),
        amountGst: isEv ? 0 : amountGst
      };
      data.fileIds = isEv ? [] : await dispatch('saveClaimFiles', files);
      await saveClaimsCall(data);
      commit('setState', ['claimSaving', false]);
      resolve();
    } catch (err) {
      commit('setState', ['claimSaving', false]);
      // eslint-disable-next-line
      console.error(err);
      Vue.prototype.$euiNotifications.emit({
        notification: GLOBAL_ERROR,
        action: () => dispatch('createClaim')
      });
      return reject();
    }
  });
}

export function saveClaimFiles({ commit, dispatch }, files) {
  return new Promise(async (resolve, reject) => {
    try {
      commit('setState', ['claimFilesSaving', true]);
      const uuids = await postFiles(files);
      commit('setState', ['claimFilesSaving', false]);
      resolve(uuids);
    } catch (err) {
      commit('setState', ['claimFilesSaving', false]);
      // eslint-disable-next-line
      console.error(err);
      Vue.prototype.$euiNotifications.emit({
        notification: GLOBAL_ERROR,
        action: () => dispatch('saveClaimFiles')
      });
      return reject();
    }
  });
}
